/**
 * URL migration rule (dev + stage + prod):
 * - User-visible UI: *.system.venza.io / venza.io
 * - SSO OAuth callback (/sso/validate) and token APIs (/auth/gettoken, /auth/token):
 *   auth-*.venzagrc.com only — do not switch these to venza.io
 */

export type PeakAuthEnv = 'dev' | 'stage' | 'prod';

export function resolvePeakAuthEnv(href: string, host: string): PeakAuthEnv {
	if (host.includes('stg.') || href.includes('stg.sys') || host.includes('tg.')) {
		return 'stage';
	}
	if (host.includes('dev.') || href.includes('dev.sys') || host.includes(':300')) {
		return 'dev';
	}
	return 'prod';
}

/** Host detection for /auth/gettoken (localhost → dev). */
export function resolvePeakAuthEnvForToken(href: string, host: string): PeakAuthEnv {
	if (host.includes('stg.') || href.includes('stg.sys') || host.includes('tg.')) {
		return 'stage';
	}
	if (
		host.includes('dev.') ||
		href.includes('dev.sys') ||
		host.includes('ev.') ||
		host.includes('192') ||
		host.includes('localhost') ||
		href.includes(':300')
	) {
		return 'dev';
	}
	return 'prod';
}

/** auth-{env}.venzagrc.com — used for /sso/validate and /auth/* token endpoints only */
export function authHostVenzagrc(env: PeakAuthEnv): string {
	return `auth-${env}.venzagrc.com`;
}

export function ssoValidateRedirectUri(env: PeakAuthEnv): string {
	return `https://${authHostVenzagrc(env)}/sso/validate`;
}

export function authGetTokenUrl(env: PeakAuthEnv): string {
	return `https://${authHostVenzagrc(env)}/auth/gettoken`;
}

/** Percent-encoded redirect_uri query param for Microsoft / Auth0 authorize URLs */
export function ssoValidateRedirectUriEncoded(env: PeakAuthEnv): string {
	return encodeURIComponent(ssoValidateRedirectUri(env));
}
